(function () {
  if (window.__lmdsAccordionReady) return;
  window.__lmdsAccordionReady = true;

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      var accordion = details.closest('.accordion');
      if (!accordion) return;
      if (accordion.classList.contains('accordion--tabs')) {
        if (!details.open) details.open = true;
        return;
      }
      if (!details.open) return;
      var summary = details.querySelector('summary') || details;
      var before = summary.getBoundingClientRect().top;
      var closed = [];
      accordion.querySelectorAll('details[open]').forEach(function (other) {
        if (other === details || other.closest('.accordion') !== accordion) return;
        other.classList.add('lmds-acc-instant');
        other.open = false;
        closed.push(other);
      });
      if (!closed.length) return;
      var shift = summary.getBoundingClientRect().top - before;
      if (Math.abs(shift) > 1) window.scrollBy({ top: shift, behavior: 'instant' });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          closed.forEach(function (other) {
            other.classList.remove('lmds-acc-instant');
          });
        });
      });
    },
    true
  );

  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var counter = 0;

    function initTabs(accordion) {
      var bar = accordion.querySelector(':scope > .lmds-tabs__head > .lmds-tabs__bar');
      var nextButton = accordion.querySelector(':scope > .lmds-tabs__head > .lmds-tabs__next');
      var track = accordion.querySelector(':scope > .lmds-tabs__track');
      if (!bar || !track || bar.querySelector('.lmds-tabs__tab')) return;
      var panels = Array.prototype.filter.call(track.children, function (el) {
        return el.querySelector('details');
      });
      if (!panels.length) return;

      counter += 1;
      var uid = 'lmdsTabs' + counter;
      var current = 0;
      var lock = null;
      var lockTimer = 0;
      var ink = document.createElement('span');
      ink.className = 'lmds-tabs__ink';
      ink.setAttribute('aria-hidden', 'true');

      var tabs = panels.map(function (panel, index) {
        var details = panel.querySelector('details');
        details.open = true;
        var summary = details.querySelector('summary');
        var label = summary ? summary.textContent.replace(/\s+/g, ' ').trim() : 'Onglet ' + (index + 1);
        var tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'lmds-tabs__tab';
        tab.id = uid + '-tab-' + index;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', uid + '-panel-' + index);
        tab.textContent = label;
        tab.addEventListener('click', function () {
          select(index, true);
        });
        panel.id = uid + '-panel-' + index;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        bar.appendChild(tab);
        return tab;
      });
      bar.appendChild(ink);

      var dots = document.createElement('div');
      dots.className = 'lmds-tabs__dots';
      dots.setAttribute('aria-hidden', 'true');
      var dotItems = panels.map(function (panel, index) {
        var dot = document.createElement('span');
        dot.className = 'lmds-tabs__dot';
        dot.addEventListener('click', function () {
          select(index, true);
        });
        dots.appendChild(dot);
        return dot;
      });
      track.insertAdjacentElement('afterend', dots);

      panels.forEach(function (panel) {
        var content = panel.querySelector('.details-content');
        if (!content) return;
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'lmds-tabs__more';
        more.hidden = true;
        more.textContent = 'Voir plus';
        more.addEventListener('click', function () {
          var expanded = content.classList.toggle('is-expanded');
          more.textContent = expanded ? 'Voir moins' : 'Voir plus';
          more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          sizeTrack();
          if (!expanded) {
            var top = accordion.getBoundingClientRect().top;
            if (top < 0) window.scrollBy({ top: top - 90, behavior: 'instant' });
          }
        });
        panel.appendChild(more);
        panel.__lmdsMore = { content: content, button: more };
      });

      function clampPanels() {
        panels.forEach(function (panel) {
          var info = panel.__lmdsMore;
          if (!info || info.content.classList.contains('is-expanded')) return;
          info.content.classList.remove('is-clamped');
          var tall = info.content.scrollHeight > 340;
          info.content.classList.toggle('is-clamped', tall);
          info.button.hidden = !tall;
          info.button.setAttribute('aria-expanded', 'false');
        });
      }

      function placeInk() {
        var tab = tabs[current];
        ink.style.width = tab.offsetWidth + 'px';
        ink.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
      }

      function sizeTrack() {
        track.style.height = panels[current].offsetHeight + 'px';
      }

      function updateNext() {
        if (!nextButton) return;
        var overflow = bar.scrollWidth > bar.clientWidth + 4;
        nextButton.hidden = !overflow || current >= tabs.length - 1;
      }

      function select(index, moveTrack) {
        current = index;
        ink.style.transition = '';
        dotItems.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (panel, i) {
          if (i === index) panel.removeAttribute('inert');
          else panel.setAttribute('inert', '');
        });
        placeInk();
        sizeTrack();
        var behavior = reduceMotion ? 'auto' : 'smooth';
        if (moveTrack) {
          lock = index;
          clearTimeout(lockTimer);
          track.style.scrollSnapType = 'none';
          track.scrollTo({ left: panels[index].offsetLeft, behavior: behavior });
          lockTimer = setTimeout(finishMove, reduceMotion ? 40 : 900);
        }
        updateNext();
        var tab = tabs[index];
        var target = tab.offsetLeft - (bar.clientWidth - tab.offsetWidth) / 2;
        bar.scrollTo({ left: Math.max(0, target), behavior: behavior });
      }

      function finishMove() {
        if (lock === null) return;
        clearTimeout(lockTimer);
        track.scrollLeft = panels[current].offsetLeft;
        track.style.scrollSnapType = '';
        requestAnimationFrame(function () {
          if (Math.abs(track.scrollLeft - panels[current].offsetLeft) > 1) {
            track.scrollLeft = panels[current].offsetLeft;
          }
          lock = null;
        });
      }

      var touching = false;
      var settleTimer = 0;
      var lastScroll = 0;

      function inkFollow() {
        var width = Math.max(1, track.clientWidth);
        var position = Math.max(0, Math.min(tabs.length - 1, track.scrollLeft / width));
        var from = Math.floor(position);
        var to = Math.min(tabs.length - 1, from + 1);
        var ratio = position - from;
        var a = tabs[from];
        var b = tabs[to];
        var left = a.offsetLeft + (b.offsetLeft - a.offsetLeft) * ratio;
        var size = a.offsetWidth + (b.offsetWidth - a.offsetWidth) * ratio;
        ink.style.transition = 'none';
        ink.style.width = size + 'px';
        ink.style.transform = 'translateX(' + left + 'px)';
      }

      function settle() {
        clearTimeout(settleTimer);
        if (lock !== null || touching) return;
        var width = Math.max(1, track.clientWidth);
        var index = Math.max(0, Math.min(panels.length - 1, Math.round(track.scrollLeft / width)));
        ink.style.transition = '';
        var aligned = Math.abs(track.scrollLeft - panels[index].offsetLeft) <= 1;
        if (index !== current || !aligned) {
          select(index, !aligned);
        } else {
          placeInk();
        }
      }

      track.addEventListener('scrollend', function () {
        if (lock !== null) finishMove();
        else settle();
      });

      track.addEventListener(
        'touchstart',
        function () {
          touching = true;
          clearTimeout(settleTimer);
        },
        { passive: true }
      );

      ['touchend', 'touchcancel'].forEach(function (type) {
        track.addEventListener(
          type,
          function () {
            touching = false;
            clearTimeout(settleTimer);
            settleTimer = setTimeout(settle, 180);
          },
          { passive: true }
        );
      });

      track.addEventListener(
        'scroll',
        function () {
          if (lock !== null) return;
          lastScroll = Date.now();
          inkFollow();
          clearTimeout(settleTimer);
          settleTimer = setTimeout(settle, 180);
        },
        { passive: true }
      );

      bar.addEventListener('keydown', function (event) {
        var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (event.key === 'Home') step = -current;
        if (event.key === 'End') step = tabs.length - 1 - current;
        if (!step) return;
        event.preventDefault();
        var next = (current + step + tabs.length) % tabs.length;
        select(next, true);
        tabs[next].focus();
      });

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          if (current < tabs.length - 1) select(current + 1, true);
        });
      }
      bar.addEventListener('scroll', updateNext, { passive: true });

      if ('IntersectionObserver' in window && !reduceMotion) {
        var peeked = false;
        var peek = new IntersectionObserver(function (entries) {
          if (peeked || !entries[0].isIntersecting) return;
          if (bar.scrollWidth <= bar.clientWidth + 4) return;
          peeked = true;
          peek.disconnect();
          setTimeout(function () {
            bar.scrollTo({ left: 56, behavior: 'smooth' });
            setTimeout(function () {
              bar.scrollTo({ left: 0, behavior: 'smooth' });
            }, 650);
          }, 400);
        }, { threshold: 0.9 });
        peek.observe(bar);
      }

      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(function () {
          clampPanels();
          placeInk();
          sizeTrack();
          updateNext();
          if (lock === null && !touching && Date.now() - lastScroll > 400 && Math.abs(track.scrollLeft - panels[current].offsetLeft) > 2) {
            track.scrollLeft = panels[current].offsetLeft;
          }
        });
        observer.observe(track);
        panels.forEach(function (panel) {
          observer.observe(panel);
        });
      }

      accordion.classList.add('is-ready');
      clampPanels();
      select(0, false);
    }

    function initAll(root) {
      (root || document).querySelectorAll('.accordion--tabs').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
    document.addEventListener('shopify:block:select', function () {
      initAll();
    });
    document.addEventListener('variant:update', function () {
      setTimeout(initAll, 60);
    });
  })();
})();
